import {
  IBaseData,
  IResponseBody,
} from "../../../../Interface/Api/BaseResponseInterface";
import {
  ECitizenRead,
  ImportantGRCategoryRead,
  ImportantGRRead,
} from "../../../../Interface/Api/ECitizenInterface";
import { SubjectRead } from "../../../../Interface/Api/SubjectDataInterface";
import { HomeSlice } from "../Home/HomeSlice";

export const EcitizenTags = HomeSlice.enhanceEndpoints({
  addTagTypes: ["e_citizen_read"],
});

const ECitizenSlice = EcitizenTags.injectEndpoints({
  endpoints: (builder) => ({
    getECitizenRead: builder.query<IBaseData<ECitizenRead[]>, string>({
      query: (lang) => ({
        url: `list-EcitizenCornerList/lang?lang=${lang}`,
        method: "GET",
      }),
      providesTags: ["e_citizen_read"],
      transformResponse: (response: IResponseBody<IBaseData<ECitizenRead[]>>) =>
        response.data as IBaseData<ECitizenRead[]>,
    }),
    getECitizenDataRead: builder.query<IBaseData<SubjectRead[]>, any>({
      query: ({ lang, payload }) => {
        const formData = new FormData();
        formData.append("titleid", payload);
        return {
          url: `list-Citizen-subinfo/lang?lang=${lang}`,
          method: "POST",
          body: formData,
        };
      },
      providesTags: ["e_citizen_read"],
      transformResponse: (response: IResponseBody<IBaseData<SubjectRead[]>>) =>
        response.data as IBaseData<SubjectRead[]>,
    }),
    // getECitizenDataRead: builder.query<
    //   IBaseData<SubjectRead[]>,
    //   string | undefined
    // >({
    //   query: ({ lang, payload }) => ({
    //     url: `list-Citizen-subinfo/lang?lang=${lang}`,
    //     method: "POST",
    //     body: payload,
    //   }),
    //   providesTags: ["e_citizen_read"],
    //   transformResponse: (response: IResponseBody<IBaseData<SubjectRead[]>>) =>
    //     response.data as IBaseData<SubjectRead[]>,
    // }),
    getImportantGRDataRead: builder.query<IBaseData<ImportantGRRead[]>, string>(
      {
        query: (lang) => ({
          url: `list-important-gr/grouped/lang?lang=${lang}`,
          method: "GET",
        }),
        transformResponse: (
          response: IResponseBody<IBaseData<ImportantGRRead[]>>
        ) => response.data as IBaseData<ImportantGRRead[]>,
      }
    ),
    getImportantGRCategoryRead: builder.query<
      IBaseData<ImportantGRCategoryRead[]>,
      string
    >({
      query: (lang) => ({
        url: `list-important-gr-master/lang?lang=${lang}`,
        method: "GET",
      }),
      transformResponse: (
        response: IResponseBody<IBaseData<ImportantGRCategoryRead[]>>
      ) => response.data as IBaseData<ImportantGRCategoryRead[]>,
    }),
    // getImportantGRDataRead: builder.query<
    //   IBaseData<ImportantGRCategoryRead[]>,
    //   string
    // >({
    //   query: (payload) => ({
    //     url: `list-important-gr`,
    //     method: "POST",
    //     body:{

    //     }
    //   }),
    //   transformResponse: (
    //     response: IResponseBody<IBaseData<ImportantGRCategoryRead[]>>
    //   ) => response.data as IBaseData<ImportantGRCategoryRead[]>,
    // }),
  }),
});

export const {
  useGetECitizenReadQuery,
  useLazyGetECitizenDataReadQuery,
  useGetImportantGRDataReadQuery,
  useGetImportantGRCategoryReadQuery,
} = ECitizenSlice;
